import {ActionCreator, TypedAction} from '@ngrx/store/src/models';
import {createAction, props} from '@ngrx/store';
import {Serializer, Serializers} from '../../interfaces/serializer';
import {DataSetDimension} from '../../interfaces/dimensions';
import {DatasetUsageComponentObject} from "../../classes/dataset-usage-component-object";

export const loadDataSetUsageDimensions: ActionCreator<'[DATASET_DIMENSIONS] Load data set usage dimension', (props: { dataSetUsage: DatasetUsageComponentObject }) => TypedAction<'[DATASET_DIMENSIONS] Load data set usage dimension'> & { dataSetUsage: DatasetUsageComponentObject }> = createAction('[DATASET_DIMENSIONS] Load data set usage dimension', props<{ dataSetUsage: DatasetUsageComponentObject }>());

export const loadDataSetDimensions: ActionCreator<'[DATASET_DIMENSIONS] Load', () => TypedAction<'[DATASET_DIMENSIONS] Load'>> = createAction('[DATASET_DIMENSIONS] Load');

export const loadDataSetDimensionsSuccess: ActionCreator<
  '[DATASET_DIMENSIONS] Load success',
  (props: { dimensions: Serializers<DataSetDimension> }) => TypedAction<'[DATASET_DIMENSIONS] Load success'> & { dimensions: Serializers<DataSetDimension> }
> = createAction('[DATASET_DIMENSIONS] Load success', props<{ dimensions: Serializers<DataSetDimension> }>());

export const loadPublicDataSetDimensions: ActionCreator<
  '[DATASET_DIMENSIONS] Load public',
  (props: { token: string, uuid: string }) => TypedAction<'[DATASET_DIMENSIONS] Load public'> & { token: string, uuid: string }
> = createAction('[DATASET_DIMENSIONS] Load public', props<{ token: string, uuid: string }>());

export const loadPublicDataSetDimensionsSuccess: ActionCreator<
    '[DATASET_DIMENSIONS] Load public success',
    (props: { dimensions: Serializers<DataSetDimension> }) => TypedAction<'[DATASET_DIMENSIONS] Load public success'> & { dimensions: Serializers<DataSetDimension> }
> = createAction('[DATASET_DIMENSIONS] Load public success', props<{ dimensions: Serializers<DataSetDimension> }>());

export const updateDataSetDimensions: ActionCreator<'[DATASET_DIMENSIONS] Update all', () => TypedAction<'[DATASET_DIMENSIONS] Update all'>> = createAction('[DATASET_DIMENSIONS] Update all');

export const updateDataSetDimensionsSuccess: ActionCreator<
  '[DATASET_DIMENSIONS] Update all success',
  (props: { dimensions: Serializers<DataSetDimension> }) => TypedAction<'[DATASET_DIMENSIONS] Update all success'> & { dimensions: Serializers<DataSetDimension> }
> = createAction('[DATASET_DIMENSIONS] Update all success', props<{ dimensions: Serializers<DataSetDimension> }>());

export const updateDataSetDimension: ActionCreator<
  '[DATASET_DIMENSIONS] Update',
  (props: { dimension: Serializer<DataSetDimension>, update: Partial<DataSetDimension> }) => TypedAction<'[DATASET_DIMENSIONS] Update'> & { dimension: Serializer<DataSetDimension>, update: Partial<DataSetDimension> }
> = createAction('[DATASET_DIMENSIONS] Update', props<{ dimension: Serializer<DataSetDimension>, update: Partial<DataSetDimension> }>());

export const updateDataSetDimensionSuccess: ActionCreator<
  '[DATASET_DIMENSIONS] Update success',
  (props: { dimension: Serializer<DataSetDimension> }) => TypedAction<'[DATASET_DIMENSIONS] Update success'> & { dimension: Serializer<DataSetDimension> }
> = createAction('[DATASET_DIMENSIONS] Update success', props<{ dimension: Serializer<DataSetDimension> }>());
